import { useEffect, useState } from "react"
import _ from "lodash"

const useStats = ({ inningStats }) => {
  const [inningRuns, setInningRuns] = useState({ home: [], away: [] })
  const [score, setScore] = useState({ home: "", away: "" })
  const [hits, setHits] = useState({ home: "", away: "" })
  const [errors, setErrors] = useState({ home: "", away: "" })

  const sumInningRuns = inningRunsArr => {
    return inningRunsArr.reduce((partialSum, runs) => {
      if (!isNaN(runs)) {
        partialSum += parseInt(runs)
      }
      return partialSum
    }, 0)
  }

  useEffect(() => {
    const homeInningStats = _.get(inningStats, "home", "")

    let homeInningRuns = [],
      homeHits = "",
      homeErrors = ""

    if (!_.isEmpty(homeInningStats)) {
      const [homeInningRunsStr, homeHitsErrorsStr] = homeInningStats.split("|")
      homeInningRuns = homeInningRunsStr.split(",")
      ;[homeHits, homeErrors] = homeHitsErrorsStr.split(",")
    }

    const awayInningStats = _.get(inningStats, "away", "")

    let awayInningRuns = [],
      awayHits = "",
      awayErrors = ""

    if (!_.isEmpty(awayInningStats)) {
      const [awayInningRunsStr, awayHitsErrorsStr] = awayInningStats.split("|")
      awayInningRuns = awayInningRunsStr.split(",")
      ;[awayHits, awayErrors] = awayHitsErrorsStr.split(",")
    }

    if (!_.isEmpty(homeInningRuns) && !_.isEmpty(awayInningRuns)) {
      setScore({
        home: sumInningRuns(homeInningRuns),
        away: sumInningRuns(awayInningRuns),
      })
    }
    setInningRuns({ home: homeInningRuns, away: awayInningRuns })
    setHits({ home: homeHits, away: awayHits })
    setErrors({ home: homeErrors, away: awayErrors })
  }, [inningStats])

  return { inningRuns, score, hits, errors }
}

export default useStats
